import { api } from "../index";
import { UserProfile } from "../types";

// Admin may use same endpoints as other users; adjust path if backend differs later.
export const getAdminProfile = async (userId: number, token?: string) => {
  const response = await api.get(
    `/users/${userId}`,
    token ? { headers: { "X-CSRF-Token": token } } : undefined
  );
  return response.data;
};

export const updateAdminProfile = async (
  userId: number,
  profileData: Partial<UserProfile>,
  token?: string
) => {
  const response = await api.put(
    `/users/${userId}`,
    profileData,
    token ? { headers: { "X-CSRF-Token": token } } : undefined
  );
  return response.data;
};
